// extracted by mini-css-extract-plugin
export default {"tabela_licitacao":"tabela_subtype_tabela_licitacao__Xfdql","btn_download":"tabela_subtype_btn_download__qyEtA","container_item_codigo":"tabela_subtype_container_item_codigo__Kt0PU"};